import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchCalendarStatus = createAction(constants.FETCH_CALENDAR_STATUS)
export const fetchCalendarStatusPending = createAction(constants.FETCH_CALENDAR_STATUS_PENDING)
export const fetchCalendarStatusSuccess = createAction(constants.FETCH_CALENDAR_STATUS_SUCCESS)
export const fetchCalendarStatusFailure = createAction(constants.FETCH_CALENDAR_STATUS_FAILURE)

export const fetchGoogleCalendars = createAction(constants.FETCH_GOOGLE_CALENDARS)
export const fetchGoogleCalendarsPending = createAction(constants.FETCH_GOOGLE_CALENDARS_PENDING)
export const fetchGoogleCalendarsSuccess = createAction(constants.FETCH_GOOGLE_CALENDARS_SUCCESS)
export const fetchGoogleCalendarsFailure = createAction(constants.FETCH_GOOGLE_CALENDARS_FAILURE)

export const updateGoogleCalendar = createAction(constants.UPDATE_GOOGLE_CALENDAR)
export const updateGoogleCalendarPending = createAction(constants.UPDATE_GOOGLE_CALENDAR_PENDING)
export const updateGoogleCalendarSuccess = createAction(constants.UPDATE_GOOGLE_CALENDAR_SUCCESS)
export const updateGoogleCalendarFailure = createAction(constants.UPDATE_GOOGLE_CALENDAR_FAILURE)


export const fetchMicrosoftCalendars = createAction(constants.FETCH_MICROSOFT_CALENDARS)
export const fetchMicrosoftCalendarsPending = createAction(constants.FETCH_MICROSOFT_CALENDARS_PENDING)
export const fetchMicrosoftCalendarsSuccess = createAction(constants.FETCH_MICROSOFT_CALENDARS_SUCCESS)
export const fetchMicrosoftCalendarsFailure = createAction(constants.FETCH_MICROSOFT_CALENDARS_FAILURE)

export const updateMicrosoftCalendar = createAction(constants.UPDATE_MICROSOFT_CALENDAR)
export const updateMicrosoftCalendarPending = createAction(constants.UPDATE_MICROSOFT_CALENDAR_PENDING)
export const updateMicrosoftCalendarSuccess = createAction(constants.UPDATE_MICROSOFT_CALENDAR_SUCCESS)
export const updateMicrosoftCalendarFailure = createAction(constants.UPDATE_MICROSOFT_CALENDAR_FAILURE)

export const updateMeetingSettingsSuccess = createAction(constants.UPDATE_MEETING_SETTINGS_SUCCESS)
export const updateMeetingSettingsFailure = createAction(constants.UPDATE_MEETING_SETTINGS_FAILURE)

export const fetchDefaultMeetingSettings = createAction(constants.FETCH_DEFAULT_MEETING_SETTINGS)
export const fetchDefaultMeetingSettingsPending = createAction(constants.FETCH_DEFAULT_MEETING_SETTINGS_PENDING)
export const fetchDefaultMeetingSettingsSuccess = createAction(constants.FETCH_DEFAULT_MEETING_SETTINGS_SUCCESS)
export const fetchDefaultMeetingSettingsFailure = createAction(constants.FETCH_DEFAULT_MEETING_SETTINGS_FAILURE)

export const updateDefaultMeetingSettings = createAction(constants.UPDATE_DEFAULT_MEETING_SETTINGS)
export const updateDefaultMeetingSettingsPending = createAction(constants.UPDATE_DEFAULT_MEETING_SETTINGS_PENDING)
export const updateDefaultMeetingSettingsSuccess = createAction(constants.UPDATE_DEFAULT_MEETING_SETTINGS_SUCCESS)
export const updateDefaultMeetingSettingsFailure = createAction(constants.UPDATE_DEFAULT_MEETING_SETTINGS_FAILURE)



// WEBPACK FOOTER //
// ./src/modules/meetings/actions.js